import { UserCard, UserStore } from '@/entities/user'
import { Button } from './button'
import { IUser } from '@/entities/user/model/types'
import { useState } from 'react'
import { CheckCircle, ChevronDown, ChevronUp } from 'lucide-react'
import { cn } from '../lib'

type Props = {
	selectedAddress: IUser
	setSelectedAddress: (str: IUser) => void
	disabled?: boolean
	exclude?: `0x${string}`[]
	title?: string
}

const NpoSelector = ({ selectedAddress, setSelectedAddress, disabled, exclude, title }: Props) => {
	const { user_npos, userData } = UserStore()
	const [isOpen, setIsOpen] = useState(false)

	const current_list =
		exclude && user_npos ? user_npos?.filter((el: IUser) => !exclude?.includes(el.address)) : user_npos

	if (!current_list || current_list?.length === 0) return <></>

	const list: IUser[] = [...current_list, userData as IUser].filter(
		(el: IUser) => el.address !== selectedAddress?.address
	)
	return (
		<div className='absolute -top-36 z-10 flex w-full flex-col gap-4 rounded-lg bg-background p-4 shadow-lg'>
			<span className='text-[grey]'>{title || 'SET NAME'}</span>
			<div className='flex w-full items-center justify-between'>
				<UserCard user={selectedAddress} onClick={e => e.preventDefault()} />
				<Button size={'icon'} variant={'outline'} onClick={() => setIsOpen(!isOpen)} disabled={disabled}>
					{isOpen ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
				</Button>
			</div>
			<div
				className={cn(
					'flex h-0 flex-col gap-4 overflow-hidden transition-all duration-300',
					isOpen && 'h-auto duration-300'
				)}
			>
				{list.map((el: IUser) => (
					<div className='flex w-full items-center justify-between'>
						<UserCard key={el.address} user={el} onClick={e => e.preventDefault()} />
						<Button
							onClick={() => {
								setSelectedAddress(el)
								setIsOpen(false)
							}}
							size={'icon'}
							variant={el.address === selectedAddress?.address ? 'success' : 'outline'}
							disabled={el.address === selectedAddress?.address}
						>
							<CheckCircle size={12} />
						</Button>
					</div>
				))}
			</div>
		</div>
	)
}

export default NpoSelector
